import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

/**
 * RTU-3 (row 0.99235) — Test-Fit modern decomposition, build-
 * deliverability canonical addition.
 *
 * Constructability assessment (AGC of America Constructability Review
 * + Mortenson / Turner constructability-review practice) — narrative
 * describing the constructability of the proposed layout against the
 * parcel and topographic context in the SED: equipment access,
 * lay-down area, crane and large-component staging, sequencing
 * constraints, and the dominant constructability risks the layout
 * introduces. Generated by `buildTestFitNarrative` (directive #10)
 * under the SNT-1 / SNT-4 instruction-shape guard; SNT-5 fallback at
 * `constructabilityAssessmentFallback` substitutes a data-grounded
 * placeholder when the model returns an empty string.
 */
export const ConstructabilityAssessmentSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const data = report.constructabilityAssessment;
  const hasData = typeof data === 'string' && data.trim().length > 0;
  return (
    <SectionShell label={label} hasData={hasData}>
      {/* W1c editorial port — the hand-rolled small-caps sub-label + <p>
          becomes an EditorialSubsection (themed label run + prose body).
          Narrative kept verbatim — single generated string, no structured
          fields to tabulate. */}
      {hasData && (
        <EditorialSubsection theme={theme} label="AGC Constructability Review + Mortenson / Turner Practice">
          {data}
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
